import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../material/material.module';
import { SmartFormModule } from 'ngx-smart-form';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MessageDialogComponent } from './message-dialog/message-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { LabelPipeModule } from './label-pipe/label-pipe.module';
import { AnagraficaMessageDialogComponent } from '../_widgets/anagrafica/anagrafica-message-dialog/anagrafica-message-dialog.component';
import { DialogHeaderComponent } from './dialog-header/dialog-header.component';
import { ErrorToastComponent } from './error-toast/error-toast.component';
import { FilterPipe } from './pipes/filter.pipe';

@NgModule({
  declarations: [
    MessageDialogComponent,
    AnagraficaMessageDialogComponent,
    DialogHeaderComponent,
    ErrorToastComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SmartFormModule,
    ReactiveFormsModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatIconModule,
    PdfViewerModule,
    LabelPipeModule,
    FilterPipe,
  ],
  exports: [
    CommonModule,
    MaterialModule,
    SmartFormModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatIconModule,
    PdfViewerModule,
    DialogHeaderComponent,
    ErrorToastComponent,
    FilterPipe,
  ],
})
export class SharedModule {}
